// extracted by mini-css-extract-plugin
module.exports = {"chipsTokenError":"Chips_chipsTokenError__3_4qH","errorMessage":"Chips_errorMessage__1Svei"};